// extracted by mini-css-extract-plugin
module.exports = {"share_download_app_page":"styles_share_download_app_page__g1yeQ","download_btn":"styles_download_btn__3OzLP","mask":"styles_mask__hxgE9"};